import Vue from 'vue'
import store from '@S'

// 获取下载URL
Vue.prototype.$getDownloadUrl = function (path, cond) {
  let token = window.localStorage.getItem(store.state.common.keyToken)
  let appCode = window.sessionStorage.getItem(store.state.common.AppCode)
  let menuCode = window.sessionStorage.getItem(store.state.common.MenuCode)
  var url = store.state.common.baseURL + path + '?Authorization=' + token + '&AppCode=' + appCode + '&MenuCode=' + menuCode
  if (cond !== '') {
    var form = ''
    for (var i in cond) {
      form += '&' + i + '=' + (cond[i] === null ? '' : cond[i])
    }
    window.location.href = url + form
  } else {
    window.location.href = url
  }
}
Vue.prototype.$getDownloadUrl2 = function (path, cond) {
  let token = window.localStorage.getItem(store.state.common.keyToken)
  let appCode = window.sessionStorage.getItem(store.state.common.AppCode)
  let menuCode = window.sessionStorage.getItem(store.state.common.MenuCode)
  var url = store.state.common.baseURL + path + '?Authorization=' + token + '&AppCode=' + appCode + '&MenuCode=' + menuCode
  window.location.href = url + '&cond=' + JSON.stringify(cond)
}
Vue.prototype.$notNull = function (obj) {
  if (obj == null) return false
  if (Array.isArray(obj)) {
    if (obj.length) {
      return true
    }
  } else if (Object.prototype.toString.call(obj) === '[object Object]') {
    if (Object.keys(obj).length) {
      return true
    }
  }
  return false
}
Vue.prototype.$checkAuth = function (menuCode) {
  let MCS = sessionStorage.getItem(store.state.common.MCS)
  if (menuCode != null && MCS.indexOf(menuCode) !== -1) {
    return true
  } else {
    return false
  }
}

/**
 * 设置 MenuCode
 * @param menuCode
 */
Vue.prototype.$setAuth = function (menuCode) {
  if (menuCode == null) return
  window.sessionStorage.setItem(store.state.common.MenuCode, menuCode)
}

/**
 * 清空数据
 */
Vue.prototype.$setDataNull = function (data) {
  let tempObj = Object.assign({}, data)
  Object.keys(tempObj).forEach(key => {
    tempObj[key] = judge(tempObj[key])
  })

  return tempObj
}

// 今日
Vue.prototype.$today = function () {
  let date = new Date()
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  return y + '-' + m + '-' + d
}

/**
 *  获取当月第一天和最后一天
 */
Vue.prototype.$getMonthFE = function () {
  let firstDate = new Date()
  firstDate.setDate(1)
  let endDate = new Date(firstDate)
  endDate.setMonth(firstDate.getMonth() + 1)
  endDate.setDate(0)
  let next1 = new Date(firstDate)
  next1.setMonth(firstDate.getMonth() + 1)
  next1.setDate(1)
  return {
    MF: firstDate,
    MN: endDate,
    NF: next1
  }
}

function judge (data) {
  // undefined || null || resulting
  if (data == null || typeof data === 'string') return ''

  // number
  if (typeof data === 'number') return 0

  // array
  if (Array.isArray(data)) return []

  // object
  if (Object.prototype.toString.call(data) === '[object Object]') return {}
}
// 时间yyyy-mm-dd
Vue.prototype.$formatDate = function (dt) {
  if (!dt) return ''
  let date = new Date(dt)
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  return y + '-' + m + '-' + d
}
// 月份yyyy-mm
Vue.prototype.$formatMonth = function (dt) {
  if (!dt) return ''
  let date = new Date(dt)
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  return y + '-' + m
}
// 季度yyyy-Q1
Vue.prototype.$formatQ = function (dt) {
  if (!dt) return ''
  let date = new Date(dt)
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  let q = 'Q1'
  if (m <= 3) {
    q = 'Q1'
  } else if (m <= 6) {
    q = 'Q2'
  } else if (m <= 9) {
    q = 'Q3'
  } else {
    q = 'Q4'
  }
  return y + '-' + q
}
// 年yyyy
Vue.prototype.$formatYear = function (dt) {
  if (!dt) return ''
  let date = new Date(dt)
  let y = date.getFullYear()
  return '' + y
}
// yyyy-MM-dd HH:mm
Vue.prototype.$formatTime = function (dt) {
  if (!dt) return ''
  let date = new Date(dt)
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let mi = date.getMinutes()
  mi = mi < 10 ? '0' + mi : mi
  return y + '-' + m + '-' + d + ' ' + h + ':' + mi
}
// 记录创建时间是否过48小时 d0 记录创建时间
Vue.prototype.$check48h = function (d0) {
  let d = new Date()
  d.setDate(d.getDate() - 2)
  let d1 = Vue.prototype.$formatTime(d)
  return d0 > d1
}
// 过滤
Vue.prototype.$filterFn = function (val, update, options) {
  if (val === '') {
    update(() => {
      return options
    })
    return options
  } else {
    let arr = []
    update(() => {
      for (let i = 0; i < options.length; i++) {
        let stamp = options[i].stamp ? options[i].stamp.includes(val) : false
        if (options[i].label.includes(val) || stamp) {
          arr.push(options[i])
        }
      }
    })
    return arr
  }
}

// 过滤
Vue.prototype.$filterLabel = function (val, update, options) {
  if (options === null) {
    return []
  }
  if (val === '') {
    update(() => {
      return options
    })
    return options
  } else {
    let arr = []
    update(() => {
      for (let i = 0; i < options.length; i++) {
        if (options[i].label.includes(val)) {
          arr.push(options[i])
        }
      }
    })
    return arr
  }
}
// 元 -> 万元
Vue.prototype.$fmtW = function (val) {
  if (val === 0) {
    val = 0
  }
  val = (val / 10000).toFixed(0)
  val = Vue.prototype.$formatNum((val))
  return `${val}`
}

// 千分位
/**
 * @param sign  金额符号
 * @param val   金额 number | string
 * @param toFiexedNum 保留几位小数
 */
Vue.prototype.$formatNum = function (sign, val, toFiexedNum) {
  if (typeof val !== 'number' && typeof val !== 'string') return ''
  val = String(val).replace(sign, '')
  val = val.replace(/,/g, '')
  let str = (toFiexedNum ? (+val).toFixed(toFiexedNum) : val) + ''
  let numStr = str.split('.')
  var b = /\B(?=(\d{3})+(?!\d))/g
  let a = numStr[0].replace(b, function (s) {
    return s + ','
  })
  if (numStr.length > 1) {
    return sign ? sign + a + '.' + numStr[1] : a + '.' + numStr[1]
  } else {
    return sign ? sign + a : a
  }
}

Vue.prototype.$strToNum = function (sign, val) {
  if (val === '' || val === undefined || val === null) {
    return 0.00
  } else {
    let num = String(val).replace(sign, '')
    num = num.replace(/,/g, '')
    return Number(num)
  }
}
Vue.prototype.$getTableHeight = function (parent, clientHeight, els) {
  let func = Vue.prototype.$getStyle
  let card = document.getElementsByClassName(parent)[0]
  let h = card ? func(card, 'paddingTop') + func(card, 'paddingBottom') : 0
  if (els && els.length) {
    for (let i = 0; i < els.length; i++) {
      let item = els[i].type === 'id' ? document.getElementById(els[i].el) : document.getElementsByClassName(els[i].el)[0]
      h += item ? item.getBoundingClientRect().height + (func(item, 'marginTop') || 0) + (func(item, 'marginBottom') || 0) + (func(item, 'paddingBottom') || 0) + (func(item, 'paddingTop') || 0) : 0
    }
    return clientHeight - h
  }
}
Vue.prototype.$getStyle = function (ele, attr) {
  if (!ele) return
  return parseFloat(document.defaultView.getComputedStyle(ele, null)[attr])
}
// 大于0的整数
Vue.prototype.$checkIntG0 = function (n) {
  if (n === null || n <= 0) {
    return false
  }
  return parseInt(n) === n
}

// 附件检查
Vue.prototype.$checkAttFiles = function (attForm) {
  var message = ''
  attForm.att_category_options.forEach((item, index) => {
    if (!this.$checkAttFileIsUpload(item.value, attForm.att_list)) {
      message += item.label + ','
    }
  })
  return message
}
// 单个附件检查
Vue.prototype.$checkAttFileIsUpload = function (attCategory, attList) {
  if (attList === null) {
    return false
  }
  var b = false
  attList.forEach((item, index) => {
    if (item.att_category === attCategory) {
      b = true
    }
  })
  return b
}
// 文件格式
Vue.prototype.$checkFilesType = function (name) {
  let index = name.lastIndexOf('.')
  let suffix = name.slice(index).toLowerCase()
  let imgType = ['.gif', '.jpg', '.jpeg', '.png']
  let pdfType = ['.pdf']
  let type = 'img'
  if (imgType.includes(suffix)) {
    type = 'img'
  } else if (pdfType.includes(suffix)) {
    type = 'pdf'
  } else {
    type = 'mp4'
  }
  return type
}

// 出入库原因
Vue.prototype.$changeTypeTitle = function (changeType) {
  switch (changeType) {
    case '1':
      return '采购入库'
    case '2':
      return '生产入库'
    case '3':
      return '销售发货'
    case '4':
      return '借出/归还'
    case '5':
      return '盘点'
    case '6':
      return '收发货'
    case '7':
      return '其他'
    default:
      return ''
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js